// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvailableItemsController from './available_items_controller'
application.register("available-items", AvailableItemsController)

import Flatpicker from 'stimulus-flatpickr'
application.register('flatpickr', Flatpicker)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)